// extracted by mini-css-extract-plugin
export default {"continer":"FilesHendler_continer__Njooy","file_box":"FilesHendler_file_box__86AI4","file_title":"FilesHendler_file_title__UvlOW","err":"FilesHendler_err__ZoZEO"};